import { Sparkles } from 'lucide-react';
import { SEED_USER } from '@/versions/v1/shared/user-seed';
import { ChatComposer } from './ChatComposer';
import { StarterCategories } from './StarterCategories';

function WelcomeGlyph() {
  return (
    <span className="inline-flex flex-shrink-0 [animation:welcome-spark-in_800ms_cubic-bezier(0.22,0.61,0.36,1)_both]">
      <span className="inline-flex [transform-origin:center] hover:[animation:welcome-spark-spin_700ms_cubic-bezier(0.34,1.56,0.64,1)]">
        <Sparkles className="h-[1.4em] w-[1.4em] text-accent-500" strokeWidth={1.6} />
      </span>
    </span>
  );
}

export function WelcomeState({
  onStarterSelect,
}: {
  onStarterSelect: (text: string) => void;
}) {
  const firstName = SEED_USER.name.split(' ')[0] ?? 'there';
  const greeting = `Hey there, ${firstName}`;

  return (
    <div className="@container mx-auto flex w-full max-w-[var(--thread-max-width)] flex-1 flex-col px-4 py-12">
      <div className="flex flex-1 flex-col items-center justify-center gap-6">
        <div
          className="flex min-w-0 max-w-full items-center gap-3 text-[clamp(1.25rem,calc(150cqi/var(--greeting-ch)),2rem)] text-zinc-900 dark:text-zinc-100"
          style={{ ['--greeting-ch' as string]: greeting.length }}
        >
          <WelcomeGlyph />
          <h1 className="whitespace-nowrap font-normal tracking-tight">{greeting}</h1>
        </div>

        <div className="w-full">
          <ChatComposer welcome />
        </div>

        <StarterCategories onPrefill={onStarterSelect} />
      </div>
    </div>
  );
}
